import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { PrescriptionMedication } from "src/api/types";
import MedicationInstruction from "src/components/MedicationInstruction";

const mapWeeksToInstrucitonIndex: string[] = ["1-4", "5-8", "9-12"];
const mapMonthsToInstruction: Record<number, string> = {
  3: "1-3",
  5: "1-5",
};

interface Props {
  detail: PrescriptionMedication;
  index: number;
  component: string;
  category: string;
  numberOfMonths: number;
}

const Medication = ({
  detail,
  index,
  component,
  category,
  numberOfMonths,
}: Props) => {
  const { t } = useTranslation();

  const durationText = useMemo(() => {
    if (category === "Hair Loss") {
      return `${t(`${component}.months`)} ${
        mapMonthsToInstruction[numberOfMonths]
      }`;
    }

    return `${t(`${component}.weeks`)} ${mapWeeksToInstrucitonIndex[index]}`;
  }, [category, component, index, numberOfMonths, t]);

  return (
    <Stack key={detail.id} spacing={0.5}>
      <Typography variant="subtitle2">{durationText}</Typography>
      <MedicationInstruction
        detail={detail}
        selected={index}
        category={category}
      />
    </Stack>
  );
};

export default Medication;
